import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SHARED_MODULES } from '@app/shared';

@Component({
  selector: 'app-card-list',
  standalone: true,
  imports: [...SHARED_MODULES],
  templateUrl: './card-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardListComponent {
  @Input() public link: string;
  @Input() public containerStyle = 'hover:border-theme-500';
}
